/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_CurrentInputs */

const en_views_current = /** @type {(inputs: Views_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`current view`)
};

const de_views_current = /** @type {(inputs: Views_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktuelle Ansicht`)
};

/**
* | output |
* | --- |
* | "current view" |
*
* @param {Views_CurrentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_current = /** @type {((inputs?: Views_CurrentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_CurrentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_current(inputs)
	return en_views_current(inputs)
});